<script setup lang="ts">
import { Check } from '@lucide/vue'

interface CheckBoxProps {
  label: string
  description?: string
}

withDefaults(defineProps<CheckBoxProps>(), {
  label: 'Some label',
})

const model = defineModel<boolean>()
</script>

<template>
  <label class="flex items-start gap-2 cursor-pointer group select-none">
    <input type="checkbox" v-model="model" class="sr-only peer" />

    <div
      :class="[
        'mt-0.5 w-4 h-4 rounded border-2 flex items-center justify-center shrink-0 transition-all duration-100',
        model
          ? 'bg-primary border-primary'
          : 'border-border group-hover:border-primary/60 bg-background',
      ]"
    >
      <Check v-if="model" :size="9" class="text-white" stroke-width="3" />
    </div>

    <div v-if="label">
      <p class="text-sm font-bold text-foreground leading-snug dark:text-white">{{ label }}</p>
      <p v-if="description" class="text-xs text-muted-foreground dark:text-white">
        {{ description }}
      </p>
    </div>
  </label>
</template>
